var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-flex tw-flex-col tw-gap-1.5"},_vm._l((_vm.content),function(paragraph,i){return _c('p',{key:i},[_vm._v("\n    "+_vm._s(paragraph)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }